// src/App.js
import React from 'react';
import UserManagement from './UserManagement.js'; // Corrected import

const App = () => {
    return (
        <div>
            <UserManagement /> {/* Corrected component reference */}
        </div>
    );
};

export default App;